// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-box {
  position: relative;
  align-self: flex-start;
}
.scroll-box__content {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.scroll-box__content::-webkit-scrollbar {
  display: none;
}
.scroll-box__track {
  position: absolute;
  top: 17px;
  right: 0;
  bottom: 17px;
  width: 16px;
  z-index: 5;
  background: #eef1f2;
}
.scroll-box__thumb {
  position: absolute;
  left: 0;
  width: 16px;
  background-color: #b8c4c9;
  border-radius: 8px;
  cursor: pointer;
}
.scroll-box__thumb:hover {
  background-color: #9fb0b6;
}
.scroll-box__content--resizable {
  resize: vertical;
  overflow-y: auto;
  overflow-x: hidden;
}
.scroll-box--resizable .scroll-box__track {
  bottom: 42px;
}
.scroll-box--resizable .scroll-box__btn--down {
  top: auto;
  bottom: 25px;
  right: 0;
}
.scroll-box__btn {
  position: absolute;
  right: 0;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  padding: 0;
  border: none;
  color: #ffffff;
  background-color: #8ea1a8;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.scroll-box__btn:hover {
  background-color: #74898f;
}
.scroll-box__btn:focus {
  outline: none;
}
.scroll-box__btn--up {
  top: 0;
  border-radius: 8px 8px 0 0;
}
.scroll-box__btn--down {
  bottom: 0;
  border-radius: 0 0 8px 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/ScrollBox.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;AACF;AACE;EAGE,qBAAA;EACA,wBAAA;AADJ;AAGI;EACE,aAAA;AADN;AAKE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AAHJ;AAME;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAJJ;AAMI;EACE,yBAAA;AAJN;AAWE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AATJ;AAcE;EACE,YAAA;AAZJ;AAgBE;EACE,SAAA;EACA,YAAA;EACA,QAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,uCAAA;AAfJ;AAiBI;EACE,yBAAA;AAfN;AAkBI;EACE,aAAA;AAhBN;AAmBI;EACE,MAAA;EACA,0BAAA;AAjBN;AAoBI;EACE,SAAA;EACA,0BAAA;AAlBN","sourcesContent":[".scroll-box {\n  position: relative;\n  align-self: flex-start;\n\n  &__content {\n    // native scrollbar replaced with our own track/thumb below, which we can\n    // reliably size to stop short of the up/down buttons in every browser\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  &__track {\n    position: absolute;\n    top: 17px;\n    right: 0;\n    bottom: 17px;\n    width: 16px;\n    z-index: 5;\n    background: #eef1f2;\n  }\n\n  &__thumb {\n    position: absolute;\n    left: 0;\n    width: 16px;\n    background-color: #b8c4c9;\n    border-radius: 8px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #9fb0b6;\n    }\n  }\n\n  // resizable table: same element scrolls and resizes (the standard,\n  // reliable native pattern) — our own button (below) is kept clear of the\n  // resize handle in the corner, independent of native scrollbar internals\n  &__content--resizable {\n    resize: vertical;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n\n  // keep the track (and down arrow, via the rule further below) clear of\n  // both the resize handle and the button in the resizable corner\n  &--resizable .scroll-box__track {\n    bottom: 42px;\n  }\n\n  // keep the down arrow well clear of the native resize handle in the corner\n  &--resizable .scroll-box__btn--down {\n    top: auto;\n    bottom: 25px;\n    right: 0;\n  }\n\n  &__btn {\n    position: absolute;\n    right: 0;\n    z-index: 6;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 17px;\n    height: 17px;\n    padding: 0;\n    border: none;\n    color: #ffffff;\n    background-color: #8ea1a8;\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n\n    &:hover {\n      background-color: #74898f;\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &--up {\n      top: 0;\n      border-radius: 8px 8px 0 0;\n    }\n\n    &--down {\n      bottom: 0;\n      border-radius: 0 0 8px 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
